export enum EAppView {
  CustomerMenu = "CustomerMenu",

  OrderTracking = "OrderTracking",

  OrderHistory = "OrderHistory",

  LoginView = "LoginView",

  SigupView = "SigupView",

  ProfileView = "ProfileView",
}
